<template>
    <div>
        <div class="items-grid">
            <div class="item" v-for="(meal, index) in data" :key="index">
                <div class="item__inner" @click="selectMeal(meal.id)">
                    <div class="item__thb">
                        <div class="item__thb__sizer">
                            <img :src="meal.img" v-if="meal.img" />
                        </div>
                    </div>
                    <span class="name" v-html="sierotki(meal.name)"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "meals-list",
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    methods: {
        selectMeal(id) {
            this.$emit('onSelectMeal', id);
        }
    }
}
</script>

<style scoped>

</style>